export default __webpack_public_path__ + "static/media/react-javascript-js-framework-facebook-svgrepo-com.a2eabce7.svg";